import PropTypes from "prop-types";

const VARIANT_CLASSES = {
  primary: "bg-brand-900 text-white hover:bg-brand-800",
  secondary: "bg-white text-text-700 border border-slate-200 hover:bg-slate-50",
  success: "bg-success text-white hover:opacity-90",
};

export default function Button({
  children,
  variant = "primary",
  type = "button",
  className = "",
  ...props
}) {
  return (
    <button
      type={type}
      className={`rounded-lg px-4 py-2 text-sm font-semibold transition ${VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.primary} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(["primary", "secondary", "success"]),
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
};
